import { Alert, Typography } from '@mui/material';
import LockClockIcon from '@mui/icons-material/LockClock';

/**
 * LockDeskClosedAlert — Shared banner shown wherever lock submission is gated
 * because the lender has paused the Lock Desk.
 *
 * @param {object} [lockDeskStatus] — Normalized status from useLockDeskStatus (optional `reason`)
 * @param {object} [sx]             — sx overrides on the Alert
 */
const LockDeskClosedAlert = ({ lockDeskStatus, sx }) => (
  <Alert severity="warning" icon={<LockClockIcon fontSize="inherit" />} sx={{ mb: 2, ...sx }}>
    <Typography variant="subtitle2">Lock Desk is currently closed</Typography>
    <Typography variant="body2">
      {lockDeskStatus?.reason
        ? lockDeskStatus.reason
        : 'Rate locking is temporarily paused by the lender. You can still run pricing, but lock requests cannot be submitted until the Lock Desk reopens.'}
    </Typography>
  </Alert>
);

export default LockDeskClosedAlert;
